module.exports = __webpack_public_path__ + "static/media/app-bar-logo.ae90c2de.svg";